import React, { useState } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import Progress from 'antd/lib/progress';
import truncate from 'lodash/truncate';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Button } from '../../Button';

const editorialImage = require('./editorial.svg');

const UnsubmittedProjectCard = ({
  handleSelectProject,
  handleDiscardProject,
  project,
}) => {
  const questionKeys = project.overviewSteps
    .find(overviewStep => overviewStep.key === 'basic_information')
    .questions.map(question => question.key);

  const questionsInfo = questionKeys.map(questionKey =>
    project.project_onboarding_infos.find(
      questionInfo => questionInfo.question.key === questionKey,
    ),
  );

  const answeredQuestions = questionsInfo.filter(
    q => !isEmpty(get(q, 'question_response')),
  );

  const total = questionKeys.length;
  const completed = answeredQuestions.length;

  const percentageCompletion = (100 * completed) / total;

  const projectName = project.project_name
    ? truncate(project.project_name, { length: 30 })
    : `Draft ${project.index + 1}`;

  const [open, setOpenPopup] = useState(false);

  return (
    <div className="col-12 col-md-6 col-lg-4 mb-4">
      <div className="card card-project border-0 card-project-unsubmitted">
        <div className="card-body text-center">
          <h4 className="t-17 text-teal">DRAFT</h4>
          <h5 className="t-18 font-weight-bold mb-5">{projectName}</h5>
          <div
            className="card-progress card-progress-editorial mx-auto mb-4"
            style={{ backgroundImage: `url(${editorialImage})` }}
          >
            <Progress
              type="circle"
              strokeWidth={8}
              width={126}
              percent={percentageCompletion}
              format={() => <div className="progress-svg-style">&nbsp;</div>}
            />
          </div>
        </div>
        <div className="card-footer border-0 bg-transparent">
          <div className="row mb-4">
            <div className="col-10 offset-1">
              <div className="row">
                <div className="col">
                  <div className="dashboard__content--project-actions-discard">
                    <Button
                      rounded
                      bordered
                      block
                      title="DISCARD"
                      onClick={() => setOpenPopup(!open)}
                    />
                    <Modal
                      isOpen={open}
                      toggle={() => setOpenPopup(!open)}
                      centered
                      className="modal-ml dashboard__content--project-actions-discard--confirm"
                    >
                      <ModalHeader toggle={() => setOpenPopup(!open)}>
                        <span className="t-18 font-weight-extrabold">
                          Discard {projectName}
                        </span>
                      </ModalHeader>
                      <ModalBody>
                        <p className="text-gray-light t-15">
                          Are your sure? All materials will be deleted. You will
                          not be
                          <br />
                          able to undo this.
                        </p>
                      </ModalBody>
                      <ModalFooter className="d-flex justify-content-end border-0">
                        <Button
                          transparent
                          className="t-14 px-4 text-danger"
                          inline
                          title="Delete"
                          onClick={() => {
                            handleDiscardProject(project);
                            setOpenPopup(!open);
                          }}
                        />
                        <Button
                          transparent
                          className="t-14 px-4 text-gray"
                          inline
                          title="Cancel"
                          onClick={() => setOpenPopup(!open)}
                        />
                      </ModalFooter>
                    </Modal>
                  </div>
                </div>
                {false && <div className="col">
                  <div className="dashboard__content--project-actions-continue">
                    <Button
                      rounded
                      block
                      title="CONTINUE"
                      onClick={() => handleSelectProject(project.id, project)}
                      className="btn-primary btn-rounded t-15"
                    />
                  </div>
                </div>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

UnsubmittedProjectCard.propTypes = {
  handleSelectProject: PropTypes.func,
  handleDiscardProject: PropTypes.func,
  project: PropTypes.shape({
    project_brief: PropTypes.string,
  }),
};

export default UnsubmittedProjectCard;



// WEBPACK FOOTER //
// ./src/components/DashboardCard/UnsubmittedProjectCard/UnsubmittedProjectCard.js